import React from 'react';
import { InfoTooltip } from '@/components/common/InfoTooltip';

interface SectionTitleProps {
  title: string;
  tooltipText?: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ title, tooltipText }) => (
  <div className="flex items-center gap-1 mb-3">
    <h3 className="text-base font-semibold text-gray-800">{title}</h3>
    {tooltipText && <InfoTooltip text={tooltipText} placement="right" />}
  </div>
);
